import { Link } from 'react-router-dom';
import { newProducts } from '@/mocks/home';

function NewProducts() {
  return (
    <section className="relative py-20 md:py-28 px-4 md:px-8 lg:px-12 bg-background-50 overflow-hidden">
      {/* Subtle decorative */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -bottom-20 right-1/3 w-[500px] h-[500px] rounded-full bg-accent-500/[0.02] blur-[140px]" />
      </div>

      <div className="max-w-7xl mx-auto relative">
        {/* Section header */}
        <div className="text-center mb-14 md:mb-20">
          <span className="inline-block px-4 py-1.5 mb-5 text-xs font-medium text-accent-600 bg-accent-50 rounded-full">
            新品推荐
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 mb-4 tracking-tight">
            全新力作 · 持续创新
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto leading-relaxed">
            新译不断突破 AI 翻译硬件边界，为全球用户带来更强大的翻译体验
          </p>
        </div>

        {/* 2 horizontal cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {newProducts.map((product) => (
            <div
              key={product.id}
              className="group bg-white rounded-2xl border border-background-200 overflow-hidden hover:border-primary-200/70 transition-all duration-400 hover:-translate-y-1 hover:shadow-[0_8px_30px_-8px_rgba(0,0,0,0.05)] flex flex-col md:flex-row"
            >
              {/* Image area */}
              <div className="md:w-2/5 h-60 md:h-auto flex-shrink-0 overflow-hidden relative">
                <img
                  src={product.imageSrc}
                  alt={product.title}
                  className="w-full h-full object-cover object-top transition-all duration-600 group-hover:scale-105"
                />
                {/* Image fade on mobile */}
                <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-white to-transparent md:hidden" />
              </div>

              {/* Content */}
              <div className="p-5 md:p-7 flex flex-col justify-center flex-1 relative">
                {/* Tag */}
                <span className="absolute top-4 right-4 px-3 py-1 text-xs font-semibold text-white bg-accent-500 rounded-full">
                  {product.tag}
                </span>

                {/* Title & subtitle */}
                <h3 className="text-xl font-bold text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors duration-300">
                  {product.title}
                </h3>
                <p className="text-sm text-primary-600 font-medium mb-3">{product.subtitle}</p>

                {/* Description */}
                <p className="text-sm text-foreground-500 leading-relaxed mb-4">{product.desc}</p>

                {/* Feature pills */}
                <div className="flex flex-wrap gap-2 mb-5">
                  {product.features.map((f, idx) => (
                    <span
                      key={idx}
                      className="text-xs font-medium text-foreground-600 bg-background-100 border border-background-200 px-2.5 py-1 rounded-full"
                    >
                      {f}
                    </span>
                  ))}
                </div>

                {/* CTA */}
                <Link
                  to={product.href}
                  className="group/link inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
                >
                  了解产品详情
                  <i className="ri-arrow-right-line group-hover/link:translate-x-0.5 transition-transform inline-block"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default NewProducts;